import API from "api";
import Session from "../../../../helpers/session";
import { exportLink } from "../../../../helpers/variables";
import { associateReadingType, compressCSVs } from "helpers/variables";

export interface includesInterface {
  type: "csv" | "pdf";
  delivery: "download" | "email";
  emailDestination?: string;
  notifications: boolean;
  notes: boolean;
  encounters: boolean;
  bgl: boolean;
  bp: boolean;
  hrt: boolean;
  spo2: boolean;
  spir: boolean;
  temp: boolean;
  wt: boolean;
  activity: boolean;
  oneCSV: boolean;
}

export const submitExport = (
  includes: includesInterface,
  start: number | string | Date | null,
  end: number | string | Date | null,
  token: string,
  memberId: string
) => {
  const vitals = ["bp", "bgl", "spo2", "wt", "temp", "spir", "hrt", "activity"];
  if (includes.delivery === "download") {
    if (includes.oneCSV) {
      let finalData: string = "";
      let csvCount = 0;
      let pendingCount = 0;
      vitals.map((vital) => {
        if (includes[vital as keyof includesInterface]) {
          pendingCount++;
          API.kore.readings
            .getForOne(
              memberId,
              token,
              vital,
              `&format=${includes.type}&updated_between=${start},${end}`
            )
            .then((csvSTR) => {
              finalData = compressCSVs(csvSTR, finalData);
              csvCount++;
              if (csvCount === pendingCount) {
                exportLink(finalData, `combined-export.csv`, "text/csv");
              }
            });
        }
      });
    } else {
      vitals.map((vital) => {
        // TODO: fix date range search for PDF, CSV is working as expected:
        if (includes[vital as keyof includesInterface]) {
          if (includes.type === "csv") {
            API.kore.readings
              .getForOne(
                memberId,
                token,
                vital,
                `&format=${includes.type}&updated_between=${start},${end}`
              )
              .then((csv) => {
                exportLink(
                  csv,
                  `${associateReadingType(vital)}-export.csv`,
                  "text/csv"
                );
              });
          } else if (includes.type === "pdf") {
            API.kore.readings.getForOnePDF(
              memberId,
              `${associateReadingType(vital)}-export`,
              token,
              vital
            );
          }
        }
      });

      // TODO: fix date range search for both csv and pdf:
      // For csv created_at may be working to sele t daterange but
      // the call is grabbing all readings during that time.
      if (includes.notes) {
        if (includes.type === "csv") {
          API.kore.notes
            .getCSV(
              Session.crackCookieToken("coordinator"),
              `${memberId}&format=csv&created_between=${start},${end}`
            )
            .then((csv) => {
              exportLink(csv, "notes-export.csv", "text/csv");
            });
        } else if (includes.type === "pdf") {
          API.kore.notes.getExportPDF(
            Session.crackCookieToken("coordinator"),
            "notes-export",
            `${memberId}&format=pdf`
          );
        }
      }

      // TODO: fix date range search: No date range functionality set
      // for encounters.
      if (includes.encounters) {
        if (includes.type === "csv") {
          API.kore.encounters
            .getCSV(
              Session.crackCookieToken("coordinator"),
              memberId,
              `&format=csv`
            )
            .then((csv) => {
              exportLink(csv, "encounters-export.csv", "text/csv");
            });
        } else if (includes.type === "pdf") {
          API.kore.encounters.getExportPDF(
            Session.crackCookieToken("coordinator"),
            memberId,
            "encounters-export",
            `&format=pdf&updated-between=${start},${end}`
          );
        }
      }

      // TODO: fix date range search: When range was added the return became an object,object.
      if (includes.notifications) {
        if (includes.type === "csv") {
          API.kore.notifications
            .getCSV(
              Session.crackCookieToken("coordinator"),
              `${memberId}&format=csv`
            )
            .then((csv) => {
              exportLink(csv, `notifications-export.csv`, "text/csv");
            });
        } else if (includes.type === "pdf") {
          API.kore.notifications.getExportPDF(
            Session.crackCookieToken("coordinator"),
            "notifications-export",
            `${memberId}&format=pdf`
          );
        }
      }
    }
  } else if (includes.delivery === "email") {
    console.log("emailed export");
  }
};
